var map = {
	"./Black_Account_Icons-01.png": 674,
	"./Black_Account_Icons-02.png": 675,
	"./Black_Account_Icons-03.png": 676,
	"./Black_Account_Icons-04.png": 677,
	"./Black_Account_Icons-05.png": 678,
	"./Black_Account_Icons-06.png": 679,
	"./Black_Account_Icons-07.png": 680,
	"./Black_Account_Icons-08.png": 681,
	"./Black_Account_Icons-09.png": 682,
	"./Black_Account_Icons-10.png": 683,
	"./Black_Account_Icons-11.png": 684,
	"./Black_Account_Icons-12.png": 685,
	"./Black_Account_Icons-13.png": 686,
	"./Black_Account_Icons-14.png": 687,
	"./FilePresentOutlined.svg": 688,
	"./accuracyAccountsDemo_downloadMT4.jpg": 689,
	"./accuracyAccountsReal_downloadMT4.jpg": 690,
	"./alert@2x.svg": 691,
	"./apple-brands.svg": 692,
	"./arrow_up_from_box.svg": 693,
	"./bankWire.svg": 694,
	"./bdswissDemo_downloadMT4.png": 695,
	"./bdswissGlobalDemo_downloadMT4.png": 696,
	"./bdswissGlobalReal02_downloadMT4.png": 697,
	"./bdswissGlobalReal03_downloadMT4.png": 698,
	"./bdswissGlobalReal04_downloadMT4.png": 699,
	"./bdswissGlobalReal05_downloadMT4.png": 700,
	"./bdswissGlobalReal_downloadMT4.png": 701,
	"./bdswissGlobalReal_downloadMT5.png": 702,
	"./bdswissReal02_downloadMT4.png": 703,
	"./bdswissReal03_downloadMT4.png": 704,
	"./bdswissReal04_downloadMT4.png": 705,
	"./bdswissReal05_downloadMT4.png": 706,
	"./bdswissReal_downloadMT4.png": 707,
	"./bdswissReal_downloadMT5.png": 708,
	"./bdswissSCDemo_downloadMT4.png": 709,
	"./bdswissSCReal01_downloadMT4.png": 710,
	"./bdswissSCReal02_downloadMT4.png": 711,
	"./bdswissSCReal03_downloadMT4.png": 712,
	"./bdswissSCReal04_downloadMT4.png": 713,
	"./bdswissSCReal05_downloadMT4.png": 714,
	"./bdswiss_grey.png": 715,
	"./bdswiss_white.png": 716,
	"./bg-image-affiliate.png": 717,
	"./bitwallet-bdSwiss-dark.svg": 718,
	"./bitwallet-bdSwiss-light.svg": 719,
	"./bitwallet-swissMarkets-dark.svg": 720,
	"./bitwallet-swissMarkets-light.svg": 721,
	"./card.svg": 722,
	"./check_circle.png": 723,
	"./chf.png": 724,
	"./competitions.png": 725,
	"./complimentary@2x.svg": 726,
	"./control-radio-off.png": 727,
	"./control-radio-on.png": 728,
	"./crypto.svg": 729,
	"./cvv.svg": 730,
	"./deposit-card.svg": 731,
	"./diners.png": 732,
	"./dkk.png": 733,
	"./document-upload-failure-dark.png": 734,
	"./document-upload-failure-light.png": 735,
	"./document-upload-success-black.png": 736,
	"./document-upload-success-dark.png": 737,
	"./document-upload-success-light.png": 738,
	"./documents-empty-dark.png": 739,
	"./documents-empty-light.png": 740,
	"./downloadPdf-light.png": 741,
	"./downloadPdf.png": 742,
	"./dpWorldTourChampionship-dark.svg": 743,
	"./dpWorldTourChampionship-light.svg": 744,
	"./eWallet.svg": 745,
	"./eur.png": 746,
	"./exp-date.svg": 747,
	"./fees@2x.svg": 748,
	"./filterIcon.png": 749,
	"./gbp.png": 750,
	"./icon-add-account.svg": 446,
	"./icon-appstore@2x.png": 751,
	"./icon-arrow-right-dark.png": 752,
	"./icon-arrow-right-light.png": 753,
	"./icon-bank-wire.svg": 754,
	"./icon-checkbox.svg": 755,
	"./icon-close-dark.svg": 756,
	"./icon-close-light.svg": 757,
	"./icon-close.png": 758,
	"./icon-contact-callback@2x.png": 759,
	"./icon-contact-callback@2x.svg": 760,
	"./icon-contact-chat@2x.png": 447,
	"./icon-contact-chat@2x.svg": 448,
	"./icon-contact-email@2x.png": 761,
	"./icon-contact-email@2x.svg": 762,
	"./icon-contact-faqs@2x.png": 763,
	"./icon-contact-faqs@2x.svg": 764,
	"./icon-contact-oneOnOneSession@2x.png": 765,
	"./icon-contact-telegram@2x.png": 766,
	"./icon-contact-whatsapp@2x.png": 767,
	"./icon-crypto.svg": 768,
	"./icon-document.svg": 769,
	"./icon-facebook@2x.png": 770,
	"./icon-google-play@2x.png": 771,
	"./icon-notification.svg": 772,
	"./icon-profile-big.svg": 773,
	"./icon-profile.svg": 774,
	"./icon-spoa.svg": 775,
	"./icon-swapFree.svg": 776,
	"./icon-telegram@2x.png": 777,
	"./icon-twitter@2x.png": 778,
	"./icon_accounts_dashboard.svg": 779,
	"./icon_logout_dashboard.svg": 780,
	"./icon_notification_dashboard.svg": 781,
	"./icon_profilesettings_dashboard.svg": 782,
	"./icon_support_dashboard.svg": 783,
	"./icon_transaction_dashboard.svg": 784,
	"./jcb.png": 785,
	"./languages.png": 786,
	"./limit-failure-dark.png": 787,
	"./limit-failure-light.png": 788,
	"./logo-accuracy.png": 789,
	"./logo-bdstrading-white.svg": 790,
	"./logo-bdstrading.svg": 791,
	"./logo-bdswiss-white.svg": 792,
	"./logo-bdswiss.png": 793,
	"./logo-bdswiss.svg": 794,
	"./logo-equityflow-black.png": 795,
	"./logo-equityflow-white.png": 796,
	"./logo-facebook.png": 797,
	"./logo-google.png": 798,
	"./logo-lydian-black.png": 799,
	"./logo-lydian-black.svg": 800,
	"./logo-lydian-white.svg": 801,
	"./logo-regalx-white.png": 802,
	"./logo-regalx.png": 803,
	"./logo-skyground-black.svg": 804,
	"./logo-skyground-white.svg": 805,
	"./logo-swissmarkets-white.svg": 806,
	"./logo-swissmarkets.png": 807,
	"./logo-swissmarkets.svg": 808,
	"./logo-tauromarkets-black.png": 809,
	"./logo-tauromarkets-white.png": 810,
	"./logo-tauromarkets-white2.png": 811,
	"./logo-tauromarkets-white2.svg": 812,
	"./logo-valutamarkets.png": 813,
	"./maestro.png": 814,
	"./mastercard.png": 815,
	"./mastercard_logo_icon.svg": 816,
	"./mercedesCup-dark.svg": 817,
	"./mercedesCup-light.svg": 818,
	"./nationalIdBR.png": 819,
	"./nationalIdES.jpg": 820,
	"./nationalIdIT.jpg": 821,
	"./nationalIdZA.png": 822,
	"./no-trades-dark.png": 823,
	"./no-trades-light.png": 824,
	"./no-trading-signals-dark.png": 825,
	"./nok.png": 826,
	"./notifications-empty-dark.png": 827,
	"./notifications-empty-light.png": 828,
	"./onlineBanking.svg": 829,
	"./onlineDeposit.svg": 830,
	"./page-not-found-dark.svg": 449,
	"./page-not-found-light.svg": 450,
	"./payment-failure-dark.png": 831,
	"./payment-failure-light.png": 832,
	"./payment-pending-dark.png": 833,
	"./payment-pending-light.png": 834,
	"./payment-success-dark.png": 835,
	"./payment-success-light.png": 836,
	"./payments-history-empty-dark.png": 837,
	"./payments-history-empty-light.png": 838,
	"./phone_verification.png": 839,
	"./place1-leadership.png": 840,
	"./place2-leadership.png": 841,
	"./place3-leadership.png": 842,
	"./pln.png": 843,
	"./pof-bankStatement.png": 844,
	"./pof-bankStatementPOF.png": 845,
	"./pof-card-back.png": 846,
	"./pof-card.png": 847,
	"./pof-cardStatement.png": 848,
	"./pof-other.png": 849,
	"./pof-proofOfResidence.png": 850,
	"./pof-swiftCopyPaymentAdvice.png": 851,
	"./pof-virtualCard.png": 852,
	"./poi-document.png": 853,
	"./poi-drivingLicense-back.png": 854,
	"./poi-drivingLicense.png": 855,
	"./poi-id-back.png": 856,
	"./poi-id.png": 857,
	"./poi-passport.png": 858,
	"./por-bankStatementPOR.png": 859,
	"./por-document.png": 860,
	"./por-proofOfResidence.png": 861,
	"./por-utilityBill.png": 862,
	"./priority@2x.svg": 863,
	"./referAndEarn.png": 864,
	"./regalxDemo_downloadMT4.png": 865,
	"./regalxReal01_downloadMT4.png": 866,
	"./regalxReal02_downloadMT4.png": 867,
	"./regalxReal03_downloadMT4.png": 868,
	"./regalxReal04_downloadMT4.png": 869,
	"./regalxReal05_downloadMT4.png": 870,
	"./register-referral-light.png": 871,
	"./sek.png": 872,
	"./sign-up.png": 873,
	"./spaceship.png": 874,
	"./spreads@2x.svg": 875,
	"./support@2x.svg": 876,
	"./swissmarketsDemo_downloadMT4.png": 877,
	"./swissmarketsReal02_downloadMT4.png": 878,
	"./swissmarketsReal_downloadMT4.png": 879,
	"./tauroDemo01DownloadMT4.jpg": 880,
	"./tauroReal01DownloadMT4.jpg": 881,
	"./technicalIndicator-ebook.png": 882,
	"./technicalIndicatorItem.svg": 883,
	"./telegram-dark.png": 884,
	"./telegram.png": 885,
	"./trading-alerts-tradingAlerts-dark.png": 886,
	"./trading-alerts-tradingAlerts-light.png": 887,
	"./tradingPsychology-ebook.png": 888,
	"./tradingPsychologyItem.svg": 889,
	"./transfer-external.svg": 890,
	"./transfer-internal.svg": 891,
	"./transfer-spoa.svg": 892,
	"./upload-bankStatement-error.png": 893,
	"./upload-bankStatement-success.png": 894,
	"./upload-bankStatement.png": 895,
	"./upload-document-dark.png": 896,
	"./upload-document-light.png": 897,
	"./upload-generic-error.png": 898,
	"./upload-generic-success.png": 899,
	"./upload-generic.png": 900,
	"./upload-pof-back-card-error.png": 901,
	"./upload-pof-back-card-success.png": 902,
	"./upload-pof-back-card.png": 903,
	"./upload-pof-front-card-error.png": 904,
	"./upload-pof-front-card-success.png": 905,
	"./upload-pof-front-card.png": 906,
	"./upload-poi-back-drivingLicense-error.png": 907,
	"./upload-poi-back-drivingLicense-success.png": 908,
	"./upload-poi-back-drivingLicense.png": 909,
	"./upload-poi-back-error.png": 910,
	"./upload-poi-back-success.png": 911,
	"./upload-poi-back.png": 912,
	"./upload-poi-front-drivingLicense-error.png": 913,
	"./upload-poi-front-drivingLicense-success.png": 914,
	"./upload-poi-front-drivingLicense.png": 915,
	"./upload-poi-front-error.png": 916,
	"./upload-poi-front-success.png": 917,
	"./upload-poi-front.png": 918,
	"./upload-por-front-error.png": 919,
	"./upload-por-front-proofOfResidence-error.png": 920,
	"./upload-por-front-proofOfResidence-success.png": 921,
	"./upload-por-front-proofOfResidence.png": 922,
	"./upload-por-front-success.png": 923,
	"./upload-por-front-utilityBill-error.png": 924,
	"./upload-por-front-utilityBill-success.png": 925,
	"./upload-por-front-utilityBill.png": 926,
	"./upload-por-front.png": 927,
	"./usd.png": 928,
	"./visa.png": 929,
	"./visa_logo_icon.svg": 930,
	"./vps-enter-credentials.png": 931,
	"./vps-remote-desktop-windows.png": 932,
	"./vps-remote-desktop.png": 933,
	"./waiting-list-skip-dark.png": 934,
	"./waiting-list-skip.png": 935,
	"./windows-brands.svg": 936
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1327;